import { Civilite } from '@/enum/Civilite'
import { ApiUserRole } from '@/enum/ApiUserRole'
import { getDefaultAloBase, AloBase } from './AloBase'

export interface AloUser extends AloBase {
        
    usrLogin: string
    usrIsDisabled: boolean
    usrChangepassOn: boolean
    usrRole: ApiUserRole|null    
    usrDatmod: string|null
    usrDatlogin: string|null
}

export const getDefaultAloUser = ():AloUser => {
    return {        
        ...getDefaultAloBase(),
        usrLogin : "",
        usrIsDisabled : true,
        usrChangepassOn: true,
        usrRole:ApiUserRole.Operator,
        usrDatmod:null,
        usrDatlogin:null,
    }
}

export const cleanAloUser = (user:AloUser) => {
    if(!user) return    
    if(!user.id) delete user.id    
}